import { GetSystemSetResult } from "@/request/modules/gen_api_4059";
import { ThemeType } from "@/utils/theme";
import { createSlice } from "@reduxjs/toolkit";
import { findIndex, remove } from "lodash";

export interface TagBar {
    key: string;
    label: React.ReactNode;
    closable: boolean;
}

interface GlobalReducer {
    collapsed: boolean;
    themeType: ThemeType;
    selectedKeys?: string[];
    openKeys?: string[];
    tags: TagBar[];
    systemConfig?: GetSystemSetResult;
}

const def_tags: TagBar[] = [{ label: "管理仪表盘", key: "/dashboard", closable: false }];

const initialState: GlobalReducer = {
    collapsed: false,
    themeType: "none",
    tags: def_tags,
};

const global = createSlice({
    name: "global",
    initialState,
    reducers: {
        setCollapsed: (state, { payload }) => {
            state.collapsed = payload;
        },
        setThemeType: (state, { payload }) => {
            state.themeType = payload;
        },
        setSelectedKeys: (state, { payload }) => {
            state.selectedKeys = payload;
        },
        setOpenKeys: (state, { payload }) => {
            state.openKeys = payload;
        },
        addTags: (state, { payload }) => {
            const index = findIndex(state.tags, (tag) => tag.key === payload.key);
            if (index >= 0) return;
            state.tags = state.tags.concat(payload);
        },
        delTags: (state, { payload }) => {
            remove(state.tags, (tag) => tag.key === payload);
        },
        clearTags: (state) => {
            state.tags = def_tags;
        },
        setSystemConfig: (state, { payload }) => {
            state.systemConfig = payload;
        }
    },
});

export default global.reducer;